import { expand, flatten } from 'jsonld';
import clonedeep from 'lodash/cloneDeep';

export const processJsonLdForRequest = async (response: any) => {
  const rawBody = clonedeep(response.body);
  // set the vocabulary mapping as the base IRI as Stardog uses it to prefix IRIs,
  // but the jsonld library is written according to its non-normative definition
  // (see https://www.w3.org/TR/json-ld11/#default-vocabulary)
  const context = response.body['@context'];
  const vocabMapping = context?.['@vocab'];
  if (context && vocabMapping) {
    context['@base'] = vocabMapping;
  }
  const expanded = await expand(rawBody);
  const flattened = await flatten(expanded);
  response.body = flattened;
};
